import {
	AddBusinessAdminContainer,
	PermissionListContainer,
} from '../../containers';
import {
	AppPage,
	MimaText,
	MimaButton,
	Modal,
	Searchbar,
} from '../../components';
import styles from '../../assets/styles/BusinessAdmin/BusinessAdmin.module.scss';
import Avatar from '../../assets/img/Mima-avatar.png';
import { AnimatePresence } from 'framer-motion';
import { userStore } from '../../stores';
import React, { useState } from 'react';

const BusinessAdmin = ({
	addAdmin,
	businessAdmins,
	goToAddAdmin,
	closeModal,
	editAdmin,
	goToEditAdmin,
}) => {
	const [filteredAdmins, setFilteredAdmins] = useState([]);
	return (
		<AppPage pageTitle="Business Admin">
			<div className={styles.upper}>
				<div className={styles.ba__num}>
					<MimaText variant="smallBold">{`${businessAdmins?.length} Admins`}</MimaText>
					<MimaText variant="xsmall"> Updated 1 min ago </MimaText>
				</div>
				<MimaButton title="Add Admin" variant="small" onClick={goToAddAdmin} />
			</div>
			<div className="searchInMiddle">
				<Searchbar
					placeholder="Search Admins"
					variant="wide"
					input={businessAdmins}
					loading={false}
					output={setFilteredAdmins}
					handleFilter={(item, searchQuery) => {
						return (
							item?.jobTitle?.toLowerCase()?.includes(searchQuery) ||
							`${item?.user?.firstname?.toLowerCase()} ${item?.user?.lastname?.toLowerCase()}`?.includes(
								searchQuery
							) ||
							item?.user?.department?.name?.toLowerCase()?.includes(searchQuery)
						);
					}}
				/>
			</div>
			<div className={styles.main}>
				{filteredAdmins.map((admin, i) => (
					<div className={styles.ba__card} key={i}>
						<img src={Avatar} alt="Admin Avatar" />
						<MimaText variant="smallBold">{`${admin.user.firstname} ${admin.user.lastname}`}</MimaText>
						<MimaText variant="small">{admin.jobTitle}</MimaText>
						<MimaText
							variant="smallBold"
							color={
								admin.access === 'Full Access'
									? 'var(--color-success)'
									: 'var(--color-grey)'
							}
						>
							{admin.access}
						</MimaText>
						<div
							className={styles.ba__card_btn}
							onClick={() => {
								userStore.setSelectedAdmin(admin);
								goToEditAdmin();
							}}
						>
							Edit Access
						</div>
					</div>
				))}
			</div>

			{(addAdmin || editAdmin) && (
				<div className="modal">
					<AnimatePresence>
						{addAdmin && <AddBusinessAdminContainer closeModal={closeModal} />}
						{editAdmin && (
							<Modal closeModal={closeModal}>
								<PermissionListContainer closeModal={closeModal} />
							</Modal>
						)}
					</AnimatePresence>
				</div>
			)}
		</AppPage>
	);
};

export default BusinessAdmin;
